import { get } from 'lodash';

export class MaintenanceMessage {
  id: number;
  type: string;
  timestamp: Date;
  startDate: string;
  msg: string;
  plainMsg: string;

  constructor(initial?: any) {
    this.id = get(initial, 'id', '');
    this.type = get(initial, 'type', '');
    this.timestamp = get(initial, 'timestamp', '');
    this.startDate = get(initial, 'startDate', '');
    this.msg = get(initial, 'msg', '');
    this.plainMsg = get(initial, 'plainMsg', '');
  }
}

export class MaintenanceMessageContent {
    id: number;
    title: string;
    content: string;
  
    constructor(initial?: any) {
      this.id = get(initial, 'id', '');
      this.title = get(initial, 'title', '');
      this.content = get(initial, 'content', '');
    }
  }
